
import CampusInfo from "../components/about_us/CampusInfo";
import TopTitle from "../components/TopTitle";
import careers from "../constants/careers.json";
import image from "../assets/img/iuta-maturin.jpg";

const campus = {
  "name": "IUTA Maturín",
  "location": {
    "address": "Edificio IUTA, Calle Barreto, con Av. Miranda, Maturín 6201, Monagas",
    "map": "https://maps.app.goo.gl/oQRs7vFCK3HyiHkY6",
    "latitude": 9.743905,
    "longitude": -63.1808544
  },
  "phone": "+58 422-848-0364",
}

function Campus() {
  return (
    <div className="main-content">
      <TopTitle title={campus.name} />
      <CampusInfo campus={campus} careers={careers} image={image} />
    </div>
  );
}

export default Campus;
